<template>
  <div class="container">
    <v-tabs
      v-model="mainTab"
      fixed-tabs
      background-color="blue accent-1 gray--text"
      class="elevation-1"
    >
      <v-tab>
        Nueva Recepcion
      </v-tab>
      <v-tab>
        Lista de recepciones
      </v-tab>
    </v-tabs>
    <v-tabs-items v-model="mainTab">
      <v-tab-item class="elevation-1">
        <v-row class="mx-1">
          <v-col cols="6" sm="6" xs="6" md="3" lg="3" xl="3">
            <label class="v-label v-label--active theme--light">Fecha Recepción</label>
            <date-picker placeholder="Fecha" class="dtpicker" v-model="reception.reception_date" format="DD-MM-YYYY" valueType="YYYY-MM-DD"></date-picker>
          </v-col>
          <v-col cols="6" sm="6" xs="6" md="3" lg="3" xl="3">
            <v-autocomplete
              v-model="reception.patent"
              :items="patents"
              :loading="isLoading"
              :search-input.sync="patentSearch"
              color="white"
              hide-no-data
              hide-selected
              item-text="IDENTIFICADOR"
              item-value="IDENTIFICADOR"
              label="Patente"
              placeholder="Seleccione camión"
              prepend-icon="mdi-database-search"
              return-object
              @change="loadPesaje"
            ></v-autocomplete>
          </v-col>
          <v-col cols="6" sm="6" xs="6" md="3" lg="3" xl="3">
            <v-select
              v-model="reception.provider"
              :items="providers"
              item-text="name"
              item-value="id"
              label="Elija Proveedor"
              color="blue darken-3"
              persistent-hint
              return-object>
            </v-select>
          </v-col>
          <v-col cols="6" sm="6" xs="6" md="3" lg="3" xl="3">
            <v-select
              v-model="reception.facility"
              :items="facilities"
              item-text="name"
              item-value="id"
              label="Elija Planta"
              color="blue darken-3"
              persistent-hint
              return-object
              @change="shippingsByFacility"
            ></v-select>
          </v-col>
          <v-col cols="6" sm="6" xs="6" md="3" lg="2" xl="2">
            <v-select
              v-model="reception.shift"
              :items="shifts"
              item-text="name"
              item-value="id"
              label="Elija Turno"
              color="blue darken-3"
              persistent-hint
              return-object>
            </v-select>
          </v-col>
          <v-col cols="6" sm="6" xs="6" md="3" lg="2" xl="2">
            <v-checkbox
              v-model="last"
              label="Ultimo Pesaje"
              color="indigo"
              hide-details
            ></v-checkbox>
          </v-col>
          <v-col cols="6" sm="6" xs="6" md="3" lg="3" xl="3">
          </v-col>
          <v-col cols="6" sm="6" xs="6" md="3" lg="2" xl="2">
            <v-btn
              color = "primary"
              @click.once="saveReception"
              :key="btnSaveKey"
            >Grabar</v-btn>
          </v-col>
          <v-col cols="6" sm="6" xs="6" md="3" lg="2" xl="2">
            <v-btn
              @click="cleanForm"
            >Limpiar</v-btn>
          </v-col>
        </v-row>
        <v-row class="mx-1">
          <v-col cols="12" sm="12" xs="12" md="12" lg="6" xl="6">
            <h3>Romana</h3>
            <v-data-table
              v-model="reception.waybills"
              :headers="waybillsListHeaders"
              :items="waybillsListBody"
              item-key="numero"
              show-select
              class="elevation-1"
              dense
              no-data-text="No hay guías"
              :hide-default-footer="true"
              disable-pagination
            >
              <template v-slot:[`item.fecha`]="{ item }">
                  {{ formatDate(item.fecha )}}
              </template>
              <template v-slot:[`item.numero`]="{ item }">
                  <a :href="url_guias + item.url_guia" target="_blank">{{ item.numero }}</a>
              </template>
            </v-data-table>
          </v-col>
          <v-col cols="12" sm="12" xs="12" md="12" lg="6" xl="6">
            <h3>Portería</h3>
            <v-data-table
              v-model="reception.ingresos"
              :headers="ingresosListHeaders"
              :items="ingresosListBody"
              class="elevation-1"
              dense
              no-data-text="No hay guías"
              :hide-default-footer="true"
              disable-pagination
            >
              <template v-slot:[`item.fecha`]="{ item }">
                  {{ formatDate(item.fecha )}}
              </template>
            </v-data-table>
          </v-col>
        </v-row>
        <v-row class="mx-1">
          <v-col cols="12" xs="12" sm="12" md="12" lg="12" xl="12">
            <v-tabs
              v-model="tab"
              fixed-tabs
              background-color="blue accent-1 gray--text"
            >
              <v-tab>
                <v-badge
                  color="green"
                  :content="plpBins"
                >
                  Bins PLP
                </v-badge>
              </v-tab>
              <v-tab>
                <v-badge
                  color="green"
                  :content="otherBins"
                >
                  Otros Bins
                </v-badge>
              </v-tab>
            </v-tabs>
            <v-tabs-items v-model="tab">
              <v-tab-item class="elevation-1">
                <v-row class="mx-1">
                  <v-col xs="12" sm="12" md="6" lg="2" xl="2">
                    <v-select
                      v-model="binColor"
                      :items="colors"
                      @change="loadBins"
                      item-text="name"
                      item-value="id"
                      label="Color"
                      color="blue darken-3"
                      persistent-hint
                      return-object>
                    </v-select>
                  </v-col>
                  <v-col xs="12" sm="12" md="6" lg="2" xl="2">
                    <v-select
                      v-model="binSize"
                      :items="sizes"
                      @change="loadBins"
                      item-text="name"
                      item-value="id"
                      label="Tamaño"
                      color="blue darken-3"
                      persistent-hint
                      return-object>
                    </v-select>
                  </v-col>
                  <v-col xs="12" sm="12" md="6" lg="3" xl="3">
                    <v-autocomplete
                      v-model="bin"
                      :items="bins"
                      :loading="isLoading"
                      :search-input.sync="binSearch"
                      color="white"
                      hide-no-data
                      hide-selected
                      item-text="number"
                      item-value="id"
                      label="Número de BIN"
                      placeholder="Escriba parte del código"
                      prepend-icon="mdi-database-search"
                      return-object
                      @change="addBin"
                    ></v-autocomplete>
                  </v-col>
                  <v-col xs="12" sm="12" md="6" lg="3" xl="3">
                    <v-select
                      v-model="state"
                      :items="states"
                      item-text="name"
                      item-value="id"
                      label="Estado del bin"
                      color="blue darken-3"
                      persistent-hint
                      return-object>
                    </v-select>
                  </v-col>
                  <v-col xs="12" sm="12" md="6" lg="2" xl="2">
                    <v-btn @click="addBin"><v-icon>mdi-plus</v-icon></v-btn>
                  </v-col>
                </v-row>
                <v-data-table 
                  :headers="binsListHeaders"
                  :items="binsListBody"
                  class="elevation-1"
                  dense
                  no-data-text="No hay bins"
                  :hide-default-footer="true"
                  disable-pagination
                >
                  <template v-slot:[`item.actions`]="{item}">
                    <v-icon
                      medium
                      @click="deleteBin(item)"
                    >
                      mdi-delete
                    </v-icon>
                  </template>
                </v-data-table>
              </v-tab-item>
              <v-tab-item class="elevation-1">
                <v-row class="mx-1">
                  <v-col xs="6" sm="4" md="3" lg="3" xl="3">
                    <v-select
                      v-model="otherOwner"
                      :items="otherOwners"
                      item-text="name"
                      item-value="id"
                      label="Elija Propietario"
                      color="blue darken-3"
                      persistent-hint
                      return-object>
                    </v-select>
                  </v-col>
                  <v-col xs="6" sm="4" md="3" lg="3" xl="3">
                    <v-select
                      v-model="color"
                      :items="colors"
                      item-text="name"
                      item-value="id"
                      label="Elija Color"
                      color="blue darken-3"
                      persistent-hint
                      return-object>
                    </v-select>
                  </v-col>
                  <v-col xs="6" sm="4" md="2" lg="2" xl="2">
                    <v-select
                      v-model="size"
                      :items="sizes"
                      item-text="name"
                      item-value="id"
                      label="Elija Tamaño"
                      color="blue darken-3"
                      persistent-hint
                      return-object>
                    </v-select>
                  </v-col>
                  <v-col xs="6" sm="4" md="2" lg="2" xl="2">
                    <v-text-field
                      placeholder="Cantidad"
                      v-model="quantity"
                    >
                    </v-text-field>
                  </v-col>
                  <v-col xs="6" sm="4" md="2" lg="2" xl="2">
                    <v-btn @click="addOtherBin" dense><v-icon>mdi-plus</v-icon></v-btn>
                  </v-col>
                </v-row>
                <v-data-table 
                  :headers="othersListHeaders"
                  :items="othersListBody"
                  class="elevation-1"
                  dense
                  no-data-text="No hay bins"
                  :hide-default-footer="true"
                  disable-pagination
                >
                  <template v-slot:[`item.code`]="{item}">
                    <v-text-field
                      prepend-icon="mdi-barcode"
                      placeholder="Codigo"
                      v-model="item.code"
                      @change= "loadBin(item)"
                    >
                    </v-text-field>
                  </template>
                  <template v-slot:[`item.actions`]="{item}">
                    <v-icon
                      medium
                      @click="deleteOtherBin(item)"
                    >mdi-delete</v-icon>
                  </template>
                </v-data-table>
              </v-tab-item>
            </v-tabs-items>
          </v-col>
        </v-row>
      </v-tab-item>
      <v-tab-item class="elevation-1">
        <v-row class="mx-1">
          <v-col cols="4">
            <v-btn @click="download" color="primary">Excel</v-btn>
          </v-col>
          <v-col cols="4">
            <v-text-field
                v-model="receptionSearch"
                append-icon="mdi-magnify"
                label="Escriba para filtrar recepciones"
                single-line
                hide-details
            ></v-text-field>
          </v-col>
        </v-row>
        <v-data-table 
          :headers="receptionsListHeaders"
          :items="receptionsListBody"
          class="elevation-1"
          no-data-text="No hay recepciones"
          :search="receptionSearch"
        >
          <template v-slot:[`item.reception_date`]="{ item }">
            {{ formatDate(item.reception_date )}}
          </template>
          <template v-slot:[`item.actions`]="{item}">
            <v-icon
              medium
              class="mr-2"
              @click="editReception(item)"
            >
              mdi-pencil
            </v-icon>
            <v-icon
              medium
              @click="deleteReception(item)"
            >
              mdi-delete
            </v-icon>
          </template>
        </v-data-table>
      </v-tab-item>
    </v-tabs-items>

    <v-snackbar
      v-model="snackbar"
      :timeout="5000"
      :color="color"
    >
      {{ validation_message }}

      <template v-slot:action="{ attrs }">
        <v-btn
          color="white"
          text
          v-bind="attrs"
          @click="snackbar = false"
        >
          Close
        </v-btn>
      </template>
    </v-snackbar>

    <!-- Modal upload -->
    <v-dialog
      v-model="selectBins"
      width="600px"
    >
      <v-card>
        <v-card-title class="green darken-1">
          Lista de bins que han sido despachados a {{ reception.facility.name }}
        </v-card-title>
        <v-container>
          <v-row class="mx-2">
            <v-text-field
                v-model="searchShipped"
                append-icon="mdi-magnify"
                label="Escriba número para filtrar bins"
                single-line
                hide-details
            ></v-text-field>
            <v-data-table 
              :headers="shippingsListHeaders"
              :items="shippings"
              class="elevation-3 mt-5"
              no-data-text="No hay bins"
              :hide-default-footer="true"
              disable-pagination
              fixed-header
              :height="table_height"
              :sort-by="['color.name', 'size.name', 'number']"
              :sort-desc="[false, false, false]"
              multi-sort
              :search="searchShipped"
            >
              <template v-slot:[`item.state.name`]="{item}">
                <v-select
                  v-model="item.state"
                  :items="states"
                  item-text="name"
                  item-value="id"
                  label="Elija estado"
                  color="blue darken-3"
                  persistent-hint
                  return-object
                  ></v-select>
              </template>
              <template v-slot:[`item.actions`]="{item}">
                <v-icon
                  medium
                  class="mr-2"
                  @click="addShippedBin(item)"
                >mdi-plus</v-icon>
              </template>
            </v-data-table>
          </v-row>
        </v-container>
        <v-card-actions>
          <v-btn
            color="primary"
            @click="selectBins = false"
          >Cerrar</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <!-- / Modal -->
  </div>
</template>

<script>
  import {mapState, mapMutations} from 'vuex'
  import DatePicker from 'vue2-datepicker';
  import 'vue2-datepicker/index.css';
  import 'vue2-datepicker/locale/es';
  export default {
    data: () => ({
      searchShipped: null,
      table_height: 600,
      selectBins: false,
      snackbar: false,
      sbcolor: 'green',
      validation_message: '',
      url_excel: '',
      receptionSearch: null,
      btnSaveKey: 1,
      dialog: false,
      errors: [],
      success: null,
      mainTab: null,
      tab: null,
      code: 0,
      facilities: [],
      shifts: [],
      bin: null,
      bins: [],
      shippings: [],
      shippingsListHeaders: [
        {
          text: 'Color',
          align: 'center',
          sortable: true,
          value: 'color.name',
          class: "salmon black--text elevation-1"
        },
        {
          text: 'Tamaño',
          align: 'center',
          sortable: true,
          value: 'size.name',
          class: "salmon black--text elevation-1"
        },
        {
          text: 'Numero',
          align: 'right',
          sortable: true,
          value: 'number',
          class: "salmon black--text elevation-1"
        },
        {
          text: 'Estado',
          align: 'center',
          sortable: true,
          value: 'state.name',
          class: "salmon black--text elevation-1"
        },
        {
          text: 'Acciones',
          align: 'center',
          sortable: false,
          value: 'actions',
          class: "salmon black--text elevation-1"
        },
      ],
      company: null,
      companies: [],
      otherOwner: null,
      otherOwners: [],
      providers: [],
      color: null,
      colors: [],
      size: null,
      binSize: {id:1, name:'1000'},
      binColor: {id:1, name:'Azul'},
      sizes: [],
      state: null,
      states: [],
      quantity: '',
      waybills: [],
      waybillPath: '',
      binSearch: null,
      facilitySearch: null,
      providerSearch: null,
      waybillSearch: null,
      patents: [],
      patentSearch: null,
      isLoading: false,
      receptionIndex: -1,
      last: false,
      reception: {
        id: 0,
        facility: {
          id: 0,
          name: ''
        },
        provider: {
          id: 0,
          name: ''
        },
        shift: {
          id: 0,
          name: ''
        },
        waybill: '',
        waybills: [],
        ingresos: [],
        patent: '',
        reception_date: new Date().toISOString().substr(0, 10),
      },
      receptionsListHeaders: [
        {
          text: 'Fecha',
          align: 'center',
          sortable: true,
          value: 'reception_date',
          class: "salmon black--text elevation-1 elevation-3"
        },
        {
          text: 'Turno',
          align: 'center',
          sortable: true,
          value: 'shift.name',
          class: "salmon black--text elevation-1 elevation-3"
        },
        {
          text: 'Patente',
          align: 'center',
          sortable: true,
          value: 'patent',
          class: "salmon black--text elevation-1 elevation-3"
        },
        {
          text: 'Proveedor',
          align: 'center',
          sortable: true,
          value: 'provider.name',
          class: "salmon black--text elevation-1 elevation-3"
        },
        {
          text: 'Planta',
          align: 'center',
          sortable: true,
          value: 'facility.name',
          class: "salmon black--text elevation-1 elevation-3"
        },
        {
          text: 'Bins',
          align: 'center',
          sortable: true,
          value: 'bins',
          class: "salmon black--text elevation-1 elevation-3"
        },
        {
          text: 'Acciones',
          align: 'center',
          sortable: false,
          value: 'actions',
          class: "salmon black--text elevation-1 elevation-3"
        },
      ],
      receptionsListBody: [],
      binsListHeaders: [
        {
          text: 'Codigo',
          align: 'center',
          sortable: true,
          value: 'bin.code',
          class: "salmon black--text elevation-1"
        },
        {
          text: 'Estado',
          align: 'center',
          sortable: true,
          value: 'state.name',
          class: "salmon black--text elevation-1"
        },
        {
          text: 'Acciones',
          align: 'center',
          sortable: false,
          value: 'actions',
          class: "salmon black--text elevation-1"
        },
      ],
      binsListBody: [],
      othersListHeaders: [
        {
          text: '#',
          align: 'center',
          sortable: true,
          value: 'quantity',
          class: "salmon black--text elevation-1"
        },
        {
          text: 'Propietario',
          align: 'center',
          sortable: true,
          value: 'company.name',
          class: "salmon black--text elevation-1"
        },
        {
          text: 'Color',
          align: 'center',
          sortable: true,
          value: 'color.name',
          class: "salmon black--text elevation-1"
        },
        {
          text: 'Tamaño',
          align: 'center',
          sortable: true,
          value: 'size.name',
          class: "salmon black--text elevation-1"
        },
        {
          text: 'Acciones',
          align: 'center',
          sortable: false,
          value: 'actions',
          class: "salmon black--text elevation-1"
        },
      ],
      othersListBody: [],
      waybillsListHeaders: [
        {
          text: 'Fecha',
          align: 'center',
          sortable: true,
          value: 'fecha',
          class: "salmon black--text elevation-1"
        },
        {
          text: 'Guia',
          align: 'center',
          sortable: true,
          value: 'numero',
          class: "salmon black--text elevation-1"
        },
        {
          text: 'Cliente',
          align: 'center',
          sortable: true,
          value: 'cliente',
          class: "salmon black--text elevation-1"
        },
        {
          text: 'Planta',
          align: 'center',
          sortable: true,
          value: 'sucursal',
          class: "salmon black--text elevation-1"
        },
      ],
      waybillsListBody: [],
      ingresosListHeaders: [
        {
          text: 'Fecha',
          align: 'center',
          sortable: true,
          value: 'fecha',
          class: "salmon black--text elevation-1"
        },
        {
          text: 'Guias',
          align: 'center',
          sortable: true,
          value: 'guias',
          class: "salmon black--text elevation-1"
        },
        {
          text: 'Origen',
          align: 'center',
          sortable: true,
          value: 'origen',
          class: "salmon black--text elevation-1"
        }
      ],
      ingresosListBody: [],
    }),
    mounted() {
      if(window.innerHeight < 768){
        this.table_height = 300;
      }
      this.loadFacilities();
      this.loadColors();
      this.loadSizes();
      this.loadStates();
      this.loadCompanies();
      this.loadShifts();
      this.loadOtherOwners();
      this.loadReceptions();
      this.loadWaybills();
      this.loadPatents();
      this.loadBins();
    },
    methods:{
      async loadCompanies(){
        let url = `${this.base_url}companies`;
        await this.axios.get(url, this.headers).then((response)=>{
            this.companies = response.data.data;
            this.providers = response.data.data;
        }).catch((error)=>{
            console.log(error);
        });
      },
      async loadOtherOwners(){
        let url = `${this.base_url}other_owners`;
        await this.axios.get(url, this.headers).then((response)=>{
            this.otherOwners = response.data.data;
        }).catch((error)=>{
            console.log(error);
        });
      },
      async loadFacilities(){
        let url = `${this.base_url}facilities`;
        await this.axios.get(url, this.headers).then((response)=>{
            this.facilities = response.data.data;
        }).catch((error)=>{
            console.log(error);
        });
      },
      async loadColors(){
        let url = `${this.base_url}colors`;
        await this.axios.get(url, this.headers).then((response)=>{
            this.colors = response.data.data;
            this.binColor = this.colors[0];
        }).catch((error)=>{
            console.log(error);
        });
      },
      async loadSizes(){
        let url = `${this.base_url}sizes`;
        await this.axios.get(url, this.headers).then((response)=>{
            this.sizes = response.data.data;
            this.binSize = this.sizes[0];
        }).catch((error)=>{
            console.log(error);
        });
      },
      async loadStates(){
        let url = `${this.base_url}states`;
        await this.axios.get(url, this.headers).then((response)=>{
            this.states = response.data.data;
            this.state = this.states[0];
        }).catch((error)=>{
            console.log(error);
        });
      },
      async loadShifts(){
        let url = `${this.base_url}shifts`;
        await this.axios.get(url, this.headers).then((response)=>{
            this.shifts = response.data.data;
        }).catch((error)=>{
            console.log(error);
        });
      },
      async loadBins(){
        let url = `${this.base_url}bins/to_receive/bysize/${this.binSize.id}/${this.binColor.id}`;
        await this.axios.get(url, this.headers).then((response)=>{
          this.bins = response.data.data;
        }).catch((error)=>{
          console.log(error);
        });
      },
      async loadWaybills(){
        if(this.reception.facility.code == '') return;
        let url = `${this.base_url}waybills/bysourcefacility/${this.reception.facility.code}`;
        await this.axios.get(url, this.headers).then((response)=>{
            this.waybills = response.data.data;
            //this.reception.waybill = {};
        }).catch((error)=>{
            console.log(error);
        });
      },
      async loadPatents(){
        let url = `${this.base_url}tickets/patents`;
        await this.axios.get(url, this.headers).then((response)=>{
            this.patents = response.data.data;
        }).catch((error)=>{
            console.log(error);
        });
      },
      async loadBin(item){
        let url = `${this.base_url}bins/${item.code}`;
        await this.axios.get(url, this.headers).then((response)=>{
            this.bin = response.data.data;
            let index = this.binsListBody.indexOf(item);
            this.binsListBody.splice(index, 1, this.bin);
        }).catch((error)=>{
            console.log(error);
        });
      },
      async loadPesaje(){
        let url = `${this.base_url}receptions/pesaje/${this.reception.patent}`;
        await this.axios.get(url, this.headers).then((response)=>{
            let pesaje = response.data.data;
            this.waybillsListBody = pesaje.documentos;
            this.ingresosListBody = pesaje.porteria;
        }).catch((error)=>{
            console.log(error);
        });
      },
      async loadReceptions(){
        let url = `${this.base_url}receptions/report/last/100`;
        await this.axios.get(url, this.headers).then((response)=>{
          this.receptionsListBody = response.data.data.report_data;
          this.url_excel = this.storage_url + response.data.data.url_excel;
        }).catch((error)=>{
          console.log(error);
        });
      },
      async shippingsByFacility(){
        this.selectBins = false;
        this.shippings  = [];
        let url = `${this.base_url}bins/shippings_by_facility/${this.reception.facility.id}`;
        await this.axios.get(url, this.headers).then((response)=>{
          this.shippings  = response.data.data;
          this.selectBins = true;
        }).catch((error)=>{
          console.log(error);
        });
      },
      async saveReception(){
        // validation
        this.success = null;
        this.validation_message = "";
        this.errors = [];
        if(!this.reception.provider.id){
          this.errors.push("Debe seleccionar un proveedor");
        }
        if(!this.reception.facility.id){
          this.errors.push("Debe seleccionar una planta");
        }
        if(!this.reception.waybills.length > 0){
          this.errors.push("Debe seleccionar una guia");
        }
        if(!this.reception.patent){
          this.errors.push("Debe seleccionar una patente");
        }
        if(!this.reception.shift.id){
          this.errors.push("Debe seleccionar un turno");
        }
        if(this.binsListBody.length == 0 && this.othersListBody.length == 0){
          this.errors.push("Debe ingresar bins");
        }
        if(this.errors.length > 0){
          this.validation_message = this.errors.join();
          this.showSnackBar(true);
          this.btnSaveKey++;
          return;
        }
        let last = this.last == true ? 1: 0;
        let url = `${this.base_url}receptions`;
        let sendData = {
          'reception':{
            'last': last,
            'main': {
              'reception_date': this.reception.reception_date,
              'shifts_id': this.reception.shift.id,
              'patent': this.reception.patent,
              'provider_id': this.reception.provider.id,
              'facility_id': this.reception.facility.id,
            },
            'waybills': [],
            'plp_details': [],
            'other_details': [],
            'gate_details': []
          }
        };
        this.ingresosListBody.forEach(detail => {
          let data = {
            'receptions_id': 0,
            'patente': detail.patente,
            'guias': detail.guias,
            'origen': detail.origen,
            'bins': detail.bins,
            'fecha_hora': detail.fecha + ' ' + detail.hora,
            'data': detail.data
          };
          sendData.reception.gate_details.push(data);
        });
        this.reception.waybills.forEach(waybill => {
          let data = {
            'reception_id': 0,
            'provider_id': this.reception.provider.id,
            'facility_id': this.reception.facility.id,
            'waybill': waybill.numero,
            'ticket': waybill.ticket,
            'pdf': waybill.pdf,
            'bins': waybill.bins
          }
          sendData.reception.waybills.push(data);
        });
        this.binsListBody.forEach(item => {
          let data = {
            'receptions_id': 0,
            'bins_id': item.bin.id,
            'state_id': item.state.id,
            'photo': ''
          }
          sendData.reception.plp_details.push(data);
        });
        this.othersListBody.forEach(bin => {
          let data = {
            'receptions_id': 0,
            'companies_id': bin.company.id,
            'colors_id': bin.color.id,
            'sizes_id': bin.size.id,
            'quantity': bin.quantity
          }
          sendData.reception.other_details.push(data);
        });
        let response = null;
        if(this.reception.id > 0){
          url = url + "/" + this.reception.id;
          try{
            response = await this.axios.put(url, JSON.stringify(sendData), this.headers);
            this.validation_message = "Grabado exitosamente!";
            this.cleanForm();
            this.showSnackBar(false);
          }catch(error){
            response = error.response;
            let msg = response.data.data;
            this.validation_message = response.status + ': ' + response.data.message + '. '+ msg;
            this.showSnackBar(true);
            this.btnSaveKey++;
          }
        }else{
          try{
            response = await this.axios.post(url, JSON.stringify(sendData), this.headers);
            this.cleanForm();
            this.showSnackBar(false);
          }catch(error){
            response = error.response;
            let msg = response.data.data;
            this.validation_message = response.status + ': ' + response.data.message + '. '+ msg;
            this.showSnackBar(true);
            this.btnSaveKey++;
          }
        }
        this.loadReceptions();
      },
      cleanForm(){
        this.binsListBody = [];
        this.othersListBody = [];
        this.reception = {
          id: 0,
          facility: {
            id: 0,
            name: ''
          },
          provider: {
            id: 0,
            name: ''
          },
          shift: {
            id: 0,
            name: ''
          },
          waybills: [],
          ingresos: [],
          patent: '',
          reception_date: new Date().toISOString().substr(0, 10),
        };
        this.waybillsListBody = [];
        this.ingresosListBody = [];
        this.btnSaveKey++;
      },
      addBin(){
        if(!this.bin || this.bin == null){
          this.validation_message = "Debe elegir un bin";
          this.showSnackBar(true);
          return;
        }
        let bin = this.binsListBody.filter(item => {
          return item.bin.number == this.bin.number && item.bin.sizes_id == this.bin.sizes_id && item.bin.colors_id == this.bin.colors_id;
        });
        if(bin.length == 0){
          this.binsListBody.push({bin: this.bin, state: this.state});
        }
      },
      addShippedBin(bin){
        let hasBin = this.binsListBody.filter(item => {
          return item.bin.number == bin.number && item.bin.sizes_id == bin.sizes_id && item.bin.colors_id == bin.colors_id;
        });
        if(hasBin.length == 0){
          this.binsListBody.push({bin: bin, state: bin.state});
          let index = this.shippings.indexOf(bin);
          this.shippings.splice(index, 1);
        }
      },
      addOtherBin(){
        if(!this.otherOwner || !this.color || !this.size || isNaN(this.quantity) || this.quantity <= 0){
          this.validation_message = "Debe ingresar todos los valores";
          this.showSnackBar(true);
          return;
        }
        this.othersListBody.push({company: this.otherOwner, color: this.color, size: this.size, quantity: this.quantity});
      },
      editReception(item) {
        this.mainTab = "1";
        this.cleanForm();
        this.receptionIndex = this.receptionsListBody.indexOf(item);
        this.reception = Object.assign({}, item);
        this.reception.reception_date = item.reception_date;
        this.binsListBody = this.reception.plp_bins;
        this.othersListBody = this.reception.other_bins;
        /*
        this.ingresosListBody = [];
        item.gate_details.forEach(g => {
          let arrF = g.fecha_hora.split(' ');
          let fecha = arrF[0];
          let p = {
            id: g.id,
            bins: g.bins,
            fecha: fecha,
            guias: g.guias,
            origen: g.origen,
          };
          this.ingresosListBody.push(p);
        });
        */
        this.reception.waybills.forEach(rw => {
          let prov = rw.provider;
          if(prov == null){
            prov = {id: 0, name: ''};
          }
          let fac = rw.facility;
          if(fac == null){
            fac = {id: 0, name: ''};
          }
          let w = {
            cliente: prov.name,
            company_id: prov.id,
            facility_id: fac.id,
            sucursal: fac.name,
            fecha: this.reception.reception_date,
            numero: rw.waybill,
            url_guia: rw.pdf,
          };
          this.waybillsListBody.push(w);
        });
      },
      deleteReception(item) {
        this.$confirm('Desea borrar esta recepción?').then(res => {
          if(res){
            let url = `${this.base_url}receptions/${item.id}`;
            this.axios.delete(url, this.headers).then((response)=>{
              console.log(response);
              const index = this.receptionsListBody.indexOf(item);
              this.receptionsListBody.splice(index, 1);
              this.showSnackBar(false);
            }).catch((error)=>{
              console.log(error);
              this.validation_message = "Error al borrar recepción";
              this.showSnackBar(true);
            });
          }
        });
      },
      deleteBin(item) {
        this.$confirm('Desea quitar este bin?').then(res => {
          if(res){
            const index = this.binsListBody.indexOf(item);
            this.binsListBody.splice(index, 1);
          }
        });
      },
      deleteOtherBin(item) {
        this.$confirm('Desea quitar este bin?').then(res => {
          if(res){
            const index = this.othersListBody.indexOf(item);
            this.othersListBody.splice(index, 1);
          }
        });
      },
      showWaybill(){
        this.waybillPath = `https://190.13.184.67/plp-ori/archivos/guias de despacho/${this.reception.waybill.URL_GUIA}.pdf`;
      },
      download(){
        window.location.href = this.url_excel;
      },
      showSnackBar(error){
        if(error){
          this.color = 'red';
        }else{
          this.color = 'green';
          this.validation_message = "Ejecutado exitosamente!";
        }
        this.snackbar = true;
      },
      formatDate (date) {
        if (!date) return null
        const [year, month, day] = date.split('-')
        return `${day}-${month}-${year}`
      },
      ...mapMutations(['actualizarBaseUrl', 'actualizarUrlGuias']),
    },
    computed:{
      plpBins: function(){
        return this.binsListBody.length;
      },
      otherBins: function(){
        let quantity = 0;
        this.othersListBody.forEach(bin => {
          quantity += parseInt(bin.quantity);
        });
        return quantity;
      },
      ...mapState(['authenticated', 'loading', 'base_url', 'url_guias', 'storage_url', 'headers'])
    },
    components:{
      DatePicker
    }
  }
</script>